import type { IFlowButton } from '@/types/flowbutton';
import type { FlowHandler, ActionMenuItem } from './index';

export const batchInvoiceHandler: FlowHandler = {
  getMenuItems(_button: IFlowButton): ActionMenuItem[] {
    return [
      {
        icon: '📂',
        label: 'Process Folder',
        onClick: () => {},
        openDialog: 'batch-invoice-pipeline',
      },
      {
        icon: '📋',
        label: 'Review Drafts',
        onClick: () => {},
        openDialog: 'batch-invoice-review',
      },
    ];
  },
};
